export default __webpack_public_path__ + "static/media/section7_image.279e2b6c.svg";